var commonFunc = function(){
	this.getDefaultStoreHrs = function(date, store) { ////added to SL 
	    if (!store.content) {
	        return false;
	    }
	    switch (date) {
	        case 7:
	            return store.content.properties.Fs_Sun_Hours.__text;
	            break;
	        case 1:
	            return store.content.properties.Fs_Mon_Hours.__text;
	            break;
	        case 2:
	            return store.content.properties.Fs_Tues_Hours.__text;
	            break;
	        case 3:
	            return store.content.properties.Fs_Wed_Hours.__text;
	            break;
	        case 4:
	            return store.content.properties.Fs_Thur_Hours.__text;
	            break;
	        case 5:
	            return store.content.properties.Fs_Fri_Hours.__text;
	            break;
	        default:
	            return store.content.properties.Fs_Sat_Hours.__text;
	            break;
	    }
	};
	this.getDefaultStoreTiming = function(date, store) { ////////added to SL   
        if (!store.content) {
            return false;
        }
        switch (date) {
            case 7:
                return store.content.properties.Rx_Sun_Hours.__text;
                break;
            case 1:
                return store.content.properties.Rx_Mon_Hours.__text;
                break;
            case 2:
                return store.content.properties.Rx_Tues_Hours.__text;
                break;
            case 3:
                return store.content.properties.Rx_Wed_Hours.__text;
                break;
            case 4:
                return store.content.properties.Rx_Thur_Hours.__text;
                break;
            case 5:
                return store.content.properties.Rx_Fri_Hours.__text;
                break;
            default:
                return store.content.properties.Rx_Sat_Hours.__text;
                break;
        }
    };
}
var cvsCommonFunc = new commonFunc();